import styled from '@emotion/styled';

const Centered = styled.div({
  margin: '10vh auto 0',
  maxWidth: '38rem',
  padding: '2rem',
  position: 'relative',
});

export default Centered;
